export enum FEATURE_FLAG_ID {
  MOOD_BAR = 1,
  TRENDING_BETS = 2,
  CASHOUT = 3,
  CASINO_ON_FEATURED_PAGE = 4,
  USER_FEEDBACK = 6,
  FEEDBACK_FORUM = 7,
  CASINO_NET_AND_TIMER = 8,
  BESPOKE_CASINO = 11,
  BESPOKE_SPORTS_MENU = 13,
  BESPOKE_COMPETITIONS = 15,
  REFER_A_FRIEND = 16,
  PROMO_CENTRE = 17,
}
